export default {
	title: 'Piano strategico',
	tabs: {
		general: {
			title: 'Generale'
		},
		filters: {
			title: 'Filtri vista'
		},
		bot: {
			title: 'IA'
		},
		export: {
			title: 'Esporta'
		},
		display: {
			title: 'Visualizzazione'
		}
	},
	filters: {
		responsible: {
			title: 'Filtro per responsabile',
			placeholder: 'Nome del responsabile'
		},
		completion: {
			title: 'Filtro completamento',
			not_started: 'Non iniziato',
			in_progress: 'In corso',
			completed: 'Completato'
		},
		dates: {
			title: 'Filtro date'
		},
		startOn: {
			title: 'Filtro data inizio',
			undefined: 'Nessuna data',
			past: 'Passato',
			ending_week: 'Inizia tra una settimana',
			ending_month: 'Inizia tra un mese',
			ending_quarter: 'Inizia tra un trimestre',
			ending_year: 'Inizia tra un anno'
		},
		endOn: {
			title: 'Filtro data fine',
			undefined: 'Nessuna data',
			done: 'Fatto',
			overdue: 'Scaduto',
			ending_week: 'Finisce tra una settimana',
			ending_month: 'Finisce tra un mese',
			ending_quarter: 'Finisce tra un trimestre',
			ending_year: 'Finisce tra un anno'
		}
	},

	display: {
		sort: {
			title: 'Ordinamento dei rami',
			startOn: 'Per data di inizio',
			name: 'Per nome',
			manual: 'Ordine manuale'
		}
	},
	all_icons: 'Filtro icone',
	no_icon: 'Nessuna icona',
	onboarding: {
		title: "Revisione del piano d'azione",
		description:
			'Verifica che assi e voci corrispondano alla tua lettura del piano.'
	}
};
